import { ActionPlan } from "@hightouch/lib/llm/action-plan/schema";
import { format } from "date-fns";

import type { AmpProjectLinkFragment } from "src/graphql";
import { ACTIONS_PATHS } from "src/pages/agents/actions/constants";
import type { DescribedLink } from "src/pages/projects/links";

type LinkedPlan = NonNullable<AmpProjectLinkFragment["amp_action_plan"]>;

export type ActionPlanStatus = "awaitingApproval" | "approved" | "replaced";

const STATUS_LABELS: Record<ActionPlanStatus, string> = {
  awaitingApproval: "Awaiting approval",
  approved: "Approved",
  replaced: "Replaced",
};

/** A session's newest plan is the only one that can be approved, and an approved plan stays approved. */
export function actionPlanStatusOf(plan: LinkedPlan): ActionPlanStatus {
  if (plan.approved_at) return "approved";
  return plan.llm_chat_session?.amp_action_plans[0]?.id === plan.id
    ? "awaitingApproval"
    : "replaced";
}

/** A plan as an attachment: its summary and its approval. It opens the plan's page under Actions. */
export function describeActionPlanLink(plan: LinkedPlan): DescribedLink {
  const parsed = ActionPlan.safeParse(plan.plan);
  const status = actionPlanStatusOf(plan);
  const approverName = plan.approved_by_user?.name;
  return {
    kind: "actionPlan",
    title: parsed.success ? parsed.data.summary : "Action plan",
    subtitle:
      status === "approved" && plan.approved_at
        ? `Approved${approverName ? ` by ${approverName}` : ""} on ${format(new Date(plan.approved_at), "MMM d")}`
        : STATUS_LABELS[status],
    href: ACTIONS_PATHS.plan(plan.id),
  };
}
